import * as React from "react";
import { Row, Col } from "antd";
import styled from "styled-components";
import { EntryComponentContainer } from "../../../shared/EntryComponentContainer";
import { BookPoint } from "../model/BookMultiOrder";
import TimeWindowPicker, { isSmallTimeWindow } from "../../../shared/TimeWindowPicker";
import { CompactLoadInputList } from "./CompactLoadInputList";
import { ReactComponent as IconX } from "../../../assets/icons/icon_x.svg";
import { AddressInput } from "../../addresses/components/AddressInput";

const StyledButton = styled.button`
  width: 180px;
  height: 43px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #386de8;
  color: #ffffff;
  cursor: pointer;
  border: none !important;
  outline: none !important;
  &:hover {
    background-color: #3d79ff;
  }
`;

const EntryHeadline = styled.span`
  color: #061a32;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

const InvisibleButton = styled.button`
  border: none !important;
  outline: none !important;
  padding: 2px;
  background-color: transparent;
  cursor: pointer;
  color: #061a32;
  svg {
    width: 20px;
    height: 20px;
  }
`;

type Props = {
  title: string;
  inputTitle: string;
  addPointButtonTitle: string;
  points: BookPoint[];
  onChange: (index: number, value: BookPoint) => void;
  onAddPoint: () => void;
  onDeletePoint: (index: number) => void;
};

export class MultiPointComponent extends React.Component<Props> {
  render() {
    const { title, points, onChange, onDeletePoint } = this.props;
    return (
      <Row type="flex">
        <Col span={24}>
          {points.map((point, index) => (
            <Row  key={index} type="flex" style={{ marginBottom: 50, borderTop: '1px solid #e8e8e8' }}>
              <Col span={11} md={11} xs={24}>
                <EntryComponentContainer 
                  style={{ marginBottom: 0,
                    height: `calc(${100 / point.loads.length}% + ${isSmallTimeWindow(point.timewindow) && point.loads.length > 1 ? '30px' : '0px' })`,
                    borderRight: 'none',
                    borderTop: 'none',
                  }}
                >
                  <Row type="flex" justify="space-between" align="middle">
                    <Col span="auto">
                      <EntryHeadline>{`${title} ${
                        points.length > 1 ? index + 1 : ""
                      }`}</EntryHeadline>{" "}
                    </Col>
                    {points.length > 1 && (
                      <Col span="auto">
                        <InvisibleButton onClick={() => onDeletePoint(index)}>
                          <IconX />
                        </InvisibleButton>
                      </Col>
                    )}
                  </Row>
                  <AddressInput
                    title={this.props.inputTitle}
                    value={point.address}
                    onChange={value =>
                      onChange(index, {
                        ...point,
                        address: value
                      })
                    }
                  />
                  <div style={{ height: "21px" }} />
                  <TimeWindowPicker
                    value={point.timewindow}
                    onChange={value =>
                      onChange(index, {
                        ...point,
                        timewindow: value
                      })
                    }
                  />
                </EntryComponentContainer>
              </Col>
              {/* load input list */}
              <Col span={13} md={13} xs={24}>
                <CompactLoadInputList
                  loads={point.loads}
                  onLoadsChange={loads => onChange(index, { ...point, loads })}
                />
              </Col>
            </Row>
          ))}
        </Col>
        {/* ADD BUTTON */}
        <Col span={24} style={{ textAlign: "center", marginBottom: 40 }}>
          <StyledButton onClick={this.props.onAddPoint}>
            {this.props.addPointButtonTitle}
          </StyledButton>
        </Col>
      </Row>
    );
  }
}
